import { 
  Modal as AntModal,
  Button as AntButton, 
} from 'antd';

import styled from 'styled-components';
import { 
  BonusModalAcceptBtnBg, 
  BonusModalRejectBtnBg 
} from '@assets';

export const Modal = styled(AntModal)`
  padding: 0px !important;

  .ant-modal-title {
    text-align: center;
    color: ${(props) => props.theme.primaryColor};
  }
  .ant-modal-content {
    background-image: url(${(prop) => prop.bg}) !important;
		background-size: contain !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
    background-color: green;
    width: 360px;
    height: 410px;
    margin: 0 auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  .ant-modal-footer {
    text-align: center;
  }

  @media screen and (max-width: 380px) {
    .ant-modal-content{
      width: 320px;
      height: 350px;
    }
  }

  @media screen and (max-width: 320px) {
    .ant-modal-content{
      width: 280px;
      height: 300px;
    }
  }
`

export const Container = styled.div`
  position: absolute;
  top: 100px;
  left: 0%;
  margin: 18px 0;
  width: 100%;
  height: 290px;

  @media screen and (max-width: 380px) {
    top: 100px;
    height: 280px;
  }
  @media screen and (max-width: 320px) {
    top: 65px;
    height: 280px;
  }
`

export const LabelContainer = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const MainText = styled.div`
  width: 70%;
  margin-top: 35px;

  color: #FFF;
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  white-space: pre-line;

  @media screen and (max-width: 380px) {
    font-size: 10px;
    margin-top: 10px;
  }

  @media screen and (max-width: 320px) {
    font-size: 8px;
    margin-top: 25px;
  }
`

export const Bottom = styled.div`
  position: absolute;
  bottom: 90px;
  width: 100%;
  left: 0%;
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 380px) {
    bottom: 115px;
  }

  @media screen and (max-width: 320px) {
    bottom: 120px;
  }
`;


export const Description = styled.div`
  margin: 0px auto 0;
  width: 60%;

  color: #FC94FF;
  text-align: center;
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; /* 160% */

  @media screen and (max-width: 380px) {
    font-size: 8px;
  }
`

export const ButtonWrapper = styled.div`

  margin: 10px 0 0 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 0 4px;
  
  svg{
    cursor: pointer;
  }

  @media screen and (max-width: 380px) {
    gap: 10px;
    padding: 0;
  }

`

const BasicButton = styled(AntButton)`
  font-size: 10px;
  width: 92px;
  height: 31px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 420px) {
    font-size: 9px;
  }

  @media screen and (max-width: 380px) {
    height: 25px;
    width: 75px;
  }

`

export const AcceptButton = styled(BasicButton)`
  background-image: url(${BonusModalAcceptBtnBg}) !important;
  background-color: transparent !important;
  background-size: cover;
  background-repeat: no-repeat;

  color: #000000 !important;
  line-height: normal;
  

  :hover{
    background-color: transparent !important;
    color: #000000 !important;
  }
`

export const RejectButton = styled(BasicButton)`
  background-image: url(${BonusModalRejectBtnBg}) !important;
  background-color: transparent !important;
  background-size: cover;
  background-repeat: no-repeat;
  padding-top: 2px;

  color: #FFF !important;

  :hover{
    background-image: url(${BonusModalRejectBtnBg}) !important;
    background-color: transparent !important;
    color: #FFF !important;
  }
`